import React, { useRef } from 'react';
import '../css/Avisos.css';

// 🔹 Imágenes
import uniforme from '../img/Avisos/uniformenz.jpg';
import Aviso2 from '../img/Avisos/Comunicado-01.jpg';
import Aviso3 from '../img/Avisos/Comunicado trabajos techumbres.jpg';
import Aviso4 from '../img/Avisos/admision2027.jpg';
import Aviso5 from '../img/Avisos/Completada.jpg';
//import Aviso10 from '../img/Respeto.jpg';
//import Aviso11 from '../img/Desayuno.jpg';


const EventsComponent = () => {

  const scrollRef = useRef(null);


  const eventsData = [

   {
      id: 5,
      date: 'Completada',
      title: 'Jueves 05 de Agosto 2026',
      description: '',
      imageUrl: Aviso5,
      type: 'auto',
    },


    {
      id: 4,
      date: 'Admisión Escolar 2027',
      title: '',
      description: '',
      imageUrl: Aviso4,
      type: 'auto',
    },


    {
      id: 3,
      date: 'Comunicado Importante',
      title: 'Viernes 15 de Mayo 2026',
      description: '',
      imageUrl: Aviso3,
      type: 'auto',
    },


    {
      id: 2,
      date: 'Comunicado Importante',
      title: 'Viernes 11 de Abril 2026',
      description: '',
      imageUrl: Aviso2,
      type: 'auto',
    },


    {
      id: 0,
      date: 'Uniforme Escolar',
      title: 'Escuela Nueva Zelandia 2025',
      description: '',
      imageUrl: uniforme,
      type: 'auto',
    },

  ];



  // Abrir archivo
  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };



  // Scroll
  const scrollLeft = () => {

    scrollRef.current.scrollBy({
      left: -320,
      behavior: 'smooth',
    });

  };


  const scrollRight = () => {

    scrollRef.current.scrollBy({
      left: 320,
      behavior: 'smooth',
    });

  };




  // Render multimedia

  const renderMedia = (event) => {

    const { imageUrl, link } = event;


    const ext = imageUrl
      .split('.')
      .pop()
      .toLowerCase();



    const handleDoubleClick = () => {

      if(link){

        window.open(link,'_blank');

      }else{

        openFileInNewTab(imageUrl);

      }

    };



    // Video

    if(
      ['mp4','mov','webm'].includes(ext)
    ){

      return (

        <video
          src={imageUrl}
          autoPlay
          loop
          muted
          playsInline
          onDoubleClick={handleDoubleClick}
          className="esc-aviso-video"
        />

      );

    }



    // PDF

    if(ext === 'pdf'){

      return (

        <div className="esc-pdf-container">

          <iframe
            src={imageUrl}
            title="Vista previa PDF"
            className="esc-pdf-preview"
          />


          <div
            className="esc-pdf-overlay"
            onDoubleClick={handleDoubleClick}
          >

            📄 Doble click para abrir

          </div>


        </div>

      );

    }




    // Imagen

    return (

      <img

        src={imageUrl}

        alt="Aviso Escuela"

        className="esc-aviso-imagen"

        onDoubleClick={handleDoubleClick}

        style={{
          cursor: link ? 'pointer':'default'
        }}

      />

    );


  };





  return (

    
      <section
         id="events-component"
        className="esc-avisos-container"
      >


      <div className="esc-avisos-header">


        <div className="esc-linea-azul"></div>


        <h2>
          INFORMACIONES IMPORTANTES
        </h2>


        <div className="esc-linea-roja"></div>


        <p>
          Comunicados, reuniones y noticias relevantes
          de nuestra comunidad educativa.
        </p>


      </div>




      <div className="esc-avisos-carousel">


        <button
          className="esc-avisos-arrow"
          onClick={scrollLeft}
        >
          ❮
        </button>




        <div

          className="esc-avisos-lista"

          ref={scrollRef}

        >


          {
            eventsData.map((event)=>(


              <article

                key={event.id}

                className="esc-aviso-card"

              >



                <div className="esc-aviso-fecha">

                  {event.date}

                </div>




                <div className="esc-aviso-contenido">


                  <h3>

                    {event.title}

                  </h3>


                  <p>

                    {event.description}

                  </p>



                  {renderMedia(event)}



                </div>



              </article>


            ))
          }



        </div>





        <button

          className="esc-avisos-arrow"

          onClick={scrollRight}

        >

          ❯

        </button>



      </div>



    </section>

  );


};


export default EventsComponent;